// extracted by mini-css-extract-plugin
export default {"selectedRecipient":"MedicalRequestFormRecipientField_selectedRecipient__s5YZW","clearRecipient":"MedicalRequestFormRecipientField_clearRecipient__cy7--"};